import { render, staticRenderFns } from "./FreshChat.vue?vue&type=template&id=1b4fcb92"
import script from "./FreshChat.vue?vue&type=script&lang=js"
export * from "./FreshChat.vue?vue&type=script&lang=js"
import style0 from "./FreshChat.vue?vue&type=style&index=0&id=1b4fcb92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports